import React from 'react';

interface TabMetric {
    label: string;
    value: number | string;
    color?: 'red' | 'green' | 'blue' | 'orange';
}

interface TabButtonProps {
    title: string;
    icon?: string;
    metrics: TabMetric[];
    active: boolean;
    onClick: () => void;
}

export const TabButton: React.FC<TabButtonProps> = ({
    title,
    icon,
    metrics,
    active,
    onClick,
}) => {
    return (
        <button
            className={`pos-tab-button ${active ? 'pos-tab-button--active' : ''}`}
            onClick={onClick}
        >
            <div className="pos-tab-button__header">
                {icon && <span className="pos-tab-button__icon">{icon}</span>}
                <h3 className="pos-tab-button__title">{title}</h3>
            </div>

            <div className="pos-tab-button__metrics">
                {metrics.map((metric, index) => (
                    <div
                        key={index}
                        className={`pos-tab-button__metric ${metric.color ? `pos-tab-button__metric--${metric.color}` : ''
                            }`}
                    >
                        <span className="pos-tab-button__metric-value">{metric.value}</span>
                        <span className="pos-tab-button__metric-label">{metric.label}</span>
                    </div>
                ))}
            </div>
        </button>
    );
};
